import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
function LoggedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-.7%",
    y: "-5.7%",
    width: "101.4%",
    height: "113.3%",
    filterUnits: "objectBoundingBox",
    id: "avatar_logged-in_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#avatar_logged-in_svg__a)",
    transform: "translate(-1616 -11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1645.118 28.375c0-6.486-5.257-11.743-11.743-11.743-6.486 0-11.743 5.257-11.743 11.743 0 6.486 5.257 11.743 11.743 11.743 6.486 0 11.743-5.257 11.743-11.743zm1.382 0c0 7.249-5.876 13.125-13.125 13.125s-13.125-5.876-13.125-13.125 5.876-13.125 13.125-13.125 13.125 5.876 13.125 13.125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1639.07 40.13a12.508 12.508 0 01-5.695 1.37 12.5 12.5 0 01-5.704-1.37c-1.017-.516-1.74-1.038-2.137-1.402a.69.69 0 01-.224-.51v-1.086c0-1.698.107-2.823.525-3.952.637-1.717 1.899-2.733 3.837-2.733h7.848c2.358 0 3.508 1.565 3.821 4.081.087.697.104 1.271.1 2.32v1.371a.69.69 0 01-.227.511c-.4.363-1.125.884-2.144 1.4zm-.86-13.828a4.835 4.835 0 11-9.67 0 4.835 4.835 0 019.67 0z"
  })));
}
export default LoggedIn;